import { render, staticRenderFns } from "./WebshopAccount.vue?vue&type=template&id=8559e07c&scoped=true&"
import script from "./WebshopAccount.vue?vue&type=script&lang=js&"
export * from "./WebshopAccount.vue?vue&type=script&lang=js&"
import style0 from "./WebshopAccount.vue?vue&type=style&index=0&id=8559e07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8559e07c",
  null
  
)

export default component.exports